import { gql } from '@apollo/client';

export const GET_QUESTIONS_BY_TAG = gql`
  query GetQuestionsByTag($tag: String!) {
    getQuestionsByTag(tag: $tag) {
      id
      prompt
      options {
        desc
        isAnswer
      }
      explanation
      tag
      label
    }
  }
`;
